import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../context/ThemeContext';

// Persistent bar shown while browsing as a guest — lets them sign in/up from
// anywhere in the preview.
export default function GuestBar() {
  const navigate = useNavigate();
  const { colors } = useTheme();
  const { t } = useTranslation();

  return (
    <div style={{
      position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 50,
      backgroundColor: colors.card, borderTop: `1px solid ${colors.cardBorder}`,
      padding: '10px max(16px, env(safe-area-inset-left)) calc(10px + env(safe-area-inset-bottom, 0px))',
      display: 'flex', alignItems: 'center', gap: 10,
    }}>
      <div style={{ flex: 1, fontSize: 13, color: colors.textSub, lineHeight: 1.35 }}>
        {t('auth.guest.bannerText')}
      </div>
      <button
        onClick={() => navigate('/login')}
        style={{
          background: 'transparent', color: colors.text, border: `1px solid ${colors.cardBorder}`,
          borderRadius: 10, padding: '10px 14px', minHeight: 44, fontSize: 14, fontWeight: 700, cursor: 'pointer',
        }}
      >
        {t('auth.guest.login')}
      </button>
      <button
        onClick={() => navigate('/register')}
        style={{
          backgroundColor: colors.accent, color: '#020617', border: 'none',
          borderRadius: 10, padding: '10px 16px', minHeight: 44, fontSize: 14, fontWeight: 800, cursor: 'pointer',
        }}
      >
        {t('auth.guest.register')}
      </button>
    </div>
  );
}
